import moment from 'moment';
import store from 'mrf/redux/store.js';
import mrf from 'mrf.config';
import i18n from 'i18next';

const DEFAULT_FORMAT = 'L LT';

/**
 * Format a given date time according to user defined parameter.
 *
 * @param date or empty string if null is passed.
 * @param {string} [pattern=undefined] moment pattern
 */
export default function dateTimeFormatter(date, pattern = undefined) {
    const systemParameters = store.getState()?.systemParameters;
    const dateTimeFormatPattern = systemParameters?.DATETIME_FORMAT_PATTERN ?? DEFAULT_FORMAT;

    if (!date) {
        return '';
    }

    let m = moment(date);

    if (mrf.utc) {
        m = moment.utc(date);
        m = m.local();
    }

    if (mrf.useMomentLocale) {
        m = m.locale(i18n.language);
    }
    
    if (pattern && typeof pattern == "string"){ //We need to check the type because of how ObjectTable handle maps
        return m.format(pattern);
    }

    return m.format(mrf.useMomentLocale ? 'L LT' : dateTimeFormatPattern);
}
